module.exports = __webpack_public_path__ + "static/clients-mobile-ebb97cc214652ab46d69c3e6bf3c0d1d.jpg";